import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CModal from '@/components/CModal.vue';
import CRadio from '@/components/shared/CRadio.vue';
import CButton from '@/components/shared/CButton';
import { DatadogEvent, fireDatadogLog } from '@/utils/datadogUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPreviewModal',
  emits: ["reset", "close"],
  setup(__props, { emit }: { emit: ({
    (event: 'reset', value: boolean): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



const closeModal = () => emit('close');

const resetWholePreview = ref(false);
const onConfirmHandler = () => {
    const action = resetWholePreview.value ? DatadogEvent.ResetPreview : DatadogEvent.ResetPreviewElements;
    fireDatadogLog(action);
    emit('reset', resetWholePreview.value);
};

return { __sfc: true,emit, closeModal, resetWholePreview, onConfirmHandler, CModal, CRadio, CButton }
}

})